import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, RadioGroup, FormControlLabel, Radio, Box } from '@mui/material';
import { API_ENDPOINTS } from '../../config/api';
import TableCard from './TableCard';
const defaultTypes = [
  { value: 'yuvarlak', label: 'Yuvarlak' },
  { value: 'dikdortgen', label: 'Dikdörtgen' },
  { value: 'kare', label: 'Kare' }
];
const TableModal = ({ open, onClose, onSaved, table, codeHash, defaultOrderNo }) => {
  const [type, setType] = useState('yuvarlak');
  const [name, setName] = useState('');
  const [seatCount, setSeatCount] = useState(8);
  const [orderNo, setOrderNo] = useState(defaultOrderNo || 1);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (table) {
      setType(table.type);
      setName(table.name);
      setSeatCount(table.seat_count);
      setOrderNo(table.order_no || 1);
    } else {
      setType('yuvarlak');
      setName('');
      setSeatCount(8);
      setOrderNo(defaultOrderNo || 1);
    }
  }, [table, defaultOrderNo]);
  const handleSave = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const method = table ? 'PUT' : 'POST';
      const url = table
        ? API_ENDPOINTS.seating.update(codeHash, table.id)
        : API_ENDPOINTS.seating.create(codeHash);
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ name, type, seat_count: seatCount, order_no: orderNo })
      });
      if (!res.ok) throw new Error('Kayıt başarısız');
      onSaved && onSaved();
      onClose && onClose();
    } catch (e) {
      // Hata gösterilebilir
    } finally {
      setLoading(false);
    }
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{table ? 'Masayı Düzenle' : 'Masa Ekle'}</DialogTitle>
      <DialogContent>
        <Box display="flex" justifyContent="center" gap={2} mb={2}>
          <RadioGroup row value={type} onChange={e => setType(e.target.value)}>
            {defaultTypes.map(opt => (
              <FormControlLabel key={opt.value} value={opt.value} control={<Radio />} label={opt.label} />
            ))}
          </RadioGroup>
        </Box>
        <TextField
          label="Masa Adı"
          value={name}
          onChange={e => setName(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
        />
        <TextField
          label="Misafir Sayısı"
          type="number"
          value={seatCount}
          onChange={e => setSeatCount(Math.max(1, Math.min(15, Number(e.target.value))))}
          fullWidth
          inputProps={{ min: 1, max: 15 }}
          sx={{ mb: 2 }}
        />
        <TextField
          label="Sıra Numarası"
          type="number"
          value={orderNo}
          onChange={e => setOrderNo(Number(e.target.value))}
          fullWidth
          inputProps={{ min: 1 }}
          sx={{ mb: 2 }}
        />
        <Box sx={{ my: 2, display: 'flex', justifyContent: 'center' }}>
          <TableCard
            table={{
              name: name || 'Masa',
              type: type,
              seat_count: seatCount,
              seats: Array.from({ length: seatCount }, (_, i) => ({ id: i + 1, seat_number: i + 1 }))
            }}
            scale={0.7}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>İptal</Button>
        <Button onClick={handleSave} variant="contained" disabled={loading || !name || seatCount < 1}>
          Kaydet
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default TableModal; 